function clampIndex(index: number, total: number): number {
  return Math.max(0, Math.min(total - 1, index));
}

export function getNextSelectedIndex(params: {
  key: string;
  currentIndex: number | null;
  total: number;
  columns: number;
}): number | null {
  const { key, currentIndex, total, columns } = params;
  if (total <= 0) return null;

  const current = currentIndex ?? 0;
  const stepColumns = Math.max(1, columns);

  switch (key) {
    case 'ArrowRight':
      return clampIndex(current + 1, total);
    case 'ArrowLeft':
      return clampIndex(current - 1, total);
    case 'ArrowDown':
      return clampIndex(current + stepColumns, total);
    case 'ArrowUp':
      return clampIndex(current - stepColumns, total);
    default:
      return null;
  }
}
